import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import DownArrowIcon from './images/down-arrow.svg';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'flex-start',
    width: 300,
    height: 54,
    background: '#fff',
    borderRadius: '3px !important',
    boxShadow: 'none',
    fontSize: '1.0625rem',
    fontFamily: 'MadaMedium',
    color: theme.palette.text.primary,
    lineHeight: '23px',
    paddingLeft: 22,
    paddingRight: 22,
    [theme.breakpoints.down('sm')]: {
      width: 260,
    },
    [theme.breakpoints.down('600')]: {
      width: '100%',
    },
    '&:hover': {
      background: '#fff',
    },
  },
  downArrowIcon: {
    position: 'absolute',
    right: 22,
  },
}));

function SearchBox({ handleClick, typeRef, value }) {
  const classes = useStyles();

  return (
    <IconButton
      className={classes.root}
      aria-label="Down Arrow"
      buttonRef={typeRef}
      onClick={handleClick}
      disableRipple
    >
      {value}
      <img
        src={DownArrowIcon}
        alt="DownArrow"
        className={classes.downArrowIcon}
      />
    </IconButton>
  );
}

SearchBox.propTypes = {
  typeRef: PropTypes.any,
  handleClick: PropTypes.func,
  value: PropTypes.string,
};

export default SearchBox;
